export class OrganizationDOAMaster {
  Id: number
  WorkflowType: string
  WorkflowTypeDisplay: string
  GroupCodeDOA: string
  DOAName: string
  FlagActive: string = "Y"
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByDisplay: string
  UpdateDate: string
  UpdateBy: string
}
